export enum Permission {
  NONE = 'NONE',
  VIEW = 'VIEW',
  ADMIN = 'ADMIN',
  CREATE_FOR_OTHERS = 'CREATE_FOR_OTHERS',
  SUPER = 'SUPER'
}
